import React, { PropsWithChildren } from "react";
//#region props
//#endregion
//#region components
import { Grid, Typography } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const DrawerEntityViewHeader: React.FC<PropsWithChildren> = (props) => {
  return (
    <Grid item xs={4}>
      <Grid item container className={cssExports.drawerEntityViewHeader} justifyContent="flex-start">
        {props.children !== undefined && (
          <Typography className={cssExports.drawerEntityViewHeaderTitle}>{props.children}</Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default DrawerEntityViewHeader;
